import script from "./AtlasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AtlasPage.vue?vue&type=script&setup=true&lang=js"

import "./AtlasPage.vue?vue&type=style&index=0&id=cbd748ae&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbd748ae"]])

export default __exports__